import React from "react"
import { Children, createContext, useContext, useEffect, useState } from 'react'
import { appTools, cn } from "lib/utils"


const TabContext = createContext({}) 
export const useTabCtx = () => useContext(TabContext)


export default function Tabset({ 
  size="md", 
  dir="horiz", 
  defaultTabIdx=0,
  tabs, 
  beforeChangeFn,
  afterChangeFn,
  className="",
  children
}: { 
  size?:string
  dir?:string
  defaultTabIdx?:number
  tabs:any
  beforeChangeFn?:any
  afterChangeFn?:any
  className?:string
  children:React.ReactNode
}) {

  const [ tabState, setTabState ] = useState<any>({ ready: true, tabs, activeTab: null })

  const getTabValue = (tab:any, prop:string = "id") => (typeof tab === "object" ? tab[prop] : tab)

  const handleTabClick = (tab:any) => {
    if( beforeChangeFn ) beforeChangeFn(tab)
    setTabState({ ...tabState, activeTab: getTabValue(tab) })
    if( afterChangeFn ) afterChangeFn(tab)
  }
  // useEffect(() => {
  //   console.log(`The active tab is: ${tabState.activeTab}`)
  // },[tabState.activeTab])

  useEffect(() => {
    if( !tabState.activeTab ){
      console.log("setting tab")
      setTabState({ ...tabState, activeTab: tabs[defaultTabIdx] })
    }
  },[tabState.activeTab])

  return (
    <div className="w-full flex flex-col justify-start items-start gap-5">

      <div className={cn(
        "w-full flex justify-start items-start gap-2",
        className
      )}>
        { tabs.map((tab:any, idx:number) => (
          <div 
            key={tab?.id || tab} 
            onClick={() => handleTabClick(tab)}
            className={cn(
              "flex grow justify-center border-b-2 border-solid border-slate-700 cursor-pointer",
              getTabValue(tab) === tabState.activeTab && "border-yellow-500"
            )}
          >
            <span>{getTabValue(tab, "label")}</span>
          </div>
        ))}
      </div>

      <div className="w-full">
        { Children.map(children, (child:any, idx:number) => child.props.id === tabState.activeTab && child )} 
      </div>
    </div>
  )

}